import React from 'react'
import {Route} from 'react-router'
import {StandardLayout} from 'common/layouts/StandardLayout'
import {UserProfilePage} from '../UserProfilePage'

export const routes = <Route component={(props) => <StandardLayout {...props} greyBg />}>
  <Route path=':id' component={({params, ...props}) => <UserProfilePage {...props} userId={parseInt(params.id, 10)} />} />
</Route>
